<app-popup-zone class="popup"
  [stats]="popupStats"
  [class.shown]="popupShown && mode === 'zone'"
  [style.left.px]="popupLeft"
  [style.top.px]="popupTop"></app-popup-zone>
<app-popup-leader class="popup"
  [stats]="popupStats"
  [class.shown]="popupShown && mode === 'zoneLeader'"
  [style.left.px]="popupLeft"
  [style.top.px]="popupTop"></app-popup-leader>
<div id="map" #map></div>
<!-- <div class="mapZoomControlWrapper">
  <div class="group">
    <div class="button" (click)="zoomIn()"><img src="/assets/img/icons/zoom-in.svg"></div>
    <div class="button" (click)="zoomOut()"><img src="/assets/img/icons/zoom-out.svg"></div>
  </div>
  <div class="button group" (click)="resetZoom()"><img src="/assets/img/icons/zoom-reset.svg"></div>
</div> -->
